




import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import ListaUsuarios from "../../componentesEspeciales/usuariosAdmin/listaUsuarios";

const LIMITE = 10;

const BADGE_TIPO = {
    Usuario:       { bg: "rgba(var(--azul-bootstrap-cta-rgb), 0.1)",  color: "var(--azul-bootstrap-cta)" },
    Soporte:       { bg: "rgba(var(--verde-bootstrap-rgb), 0.1)",   color: "var(--verde-bootstrap)" },
    Moderador:     { bg: "rgba(var(--violeta-bootstrap-rgb), 0.1)",  color: "var(--violeta-bootstrap)" },
    Contador:      { bg: "rgba(var(--amarillo-warning-rgb), 0.15)",  color: "var(--dorado)" },
    Administrador: { bg: "rgba(var(--naranja-mapa-rgb), 0.1)",  color: "var(--naranja-mapa)" },
    SuperAdmin:    { bg: "rgba(var(--rojo-error-rgb), 0.1)",   color: "var(--rojo-error)" },
};

const BADGE_ESTADO = {
    hold:       { bg: "rgba(var(--amarillo-warning-rgb), 0.15)",  color: "var(--dorado-oscuro)",  label: "Pendiente" },
    confirmado: { bg: "rgba(var(--azul-bootstrap-cta-rgb), 0.1)",  color: "var(--azul-bootstrap-cta)",  label: "Confirmado" },
    completado: { bg: "rgba(var(--verde-bootstrap-rgb), 0.1)",   color: "var(--verde-bootstrap)",  label: "Completado" },
    cancelado:  { bg: "rgba(var(--rojo-error-rgb), 0.1)",   color: "var(--rojo-error)",  label: "Cancelado" },
    expirado:   { bg: "rgba(var(--gris-suave-rgb), 0.1)", color: "var(--gris-suave)",  label: "Expirado" },
};

function fmt(fecha) {
    if (!fecha) return "—";
    return new Date(fecha).toLocaleDateString("es-CO", { day: "2-digit", month: "short", year: "numeric" });
}

function fmtMonto(n) {
    if (!n) return null;
    return "$" + new Intl.NumberFormat("es-CO").format(n);
}

function ReservasPorUsuario() {
    const navigate = useNavigate();

    // Búsqueda de usuario
    const [query, setQuery]           = useState("");
    const [resultados, setResultados] = useState([]);
    const [buscando, setBuscando]     = useState(false);
    const [buscado, setBuscado]       = useState(false);
    const timerRef                    = useRef(null);

    // Usuario seleccionado
    const [usuarioSel, setUsuarioSel] = useState(null);

    // Lista paginada de usuarios
    const [lista, setLista]               = useState([]);
    const [cargandoLista, setCargandoLista] = useState(false);
    const [paginaLista, setPaginaLista]   = useState(1);
    const [paginasLista, setPaginasLista] = useState(1);
    const [totalLista, setTotalLista]     = useState(0);

    useEffect(() => {
        (async () => {
            try {
                setCargandoLista(true);
                const res = await axios.post("/listar-usuarios-admin", { params: { pagina: paginaLista } });
                setLista(res.data.usuarios || []);
                setPaginasLista(res.data.paginas || 1);
                setTotalLista(res.data.total || 0);
            } catch { setLista([]); }
            finally { setCargandoLista(false); }
        })();
    }, [paginaLista]);

    function cambiarPaginaLista(p) {
        setPaginaLista(p);
        window.scrollTo({ top: 0, behavior: "smooth" });
    }

    // Reservas
    const [tab, setTab]               = useState("comprador");
    const [reservas, setReservas]     = useState([]);
    const [cargandoRes, setCargandoRes] = useState(false);
    const [pagina, setPagina]         = useState(1);
    const [paginas, setPaginas]       = useState(0);
    const [total, setTotal]           = useState(0);

    // ── Buscador ──────────────────────────────────────────────
    function onQueryChange(e) {
        const v = e.target.value;
        setQuery(v);

        if (!v.trim()) {
            setResultados([]);
            setBuscado(false);
            return;
        }
        clearTimeout(timerRef.current);
        timerRef.current = setTimeout(() => buscarUsuario(v.trim()), 400);
    }

    async function buscarUsuario(q) {
        try {
            setBuscando(true);
            const res = await axios.post("/buscar-usuarios", { params: { query: q } });
            setResultados(res?.data?.usuarios || []);
            setBuscado(true);
        } catch {
            setResultados([]);
            setBuscado(true);
        } finally {
            setBuscando(false);
        }
    }

    // ── Seleccionar usuario ───────────────────────────────────
    async function seleccionarUsuario(u) {
        setUsuarioSel(u);
        setResultados([]);
        setBuscado(false);
        setQuery("");
        setTab("comprador");
        await cargarReservas(u.idUsuario, "comprador", 1);
    }

    function limpiarSeleccion() {
        setUsuarioSel(null);
        setReservas([]);
        setPagina(1);
        setPaginas(0);
        setTotal(0);
    }

    // ── Cargar reservas ───────────────────────────────────────
    async function cargarReservas(idUsuario, rol, pag) {
        try {
            setCargandoRes(true);
            const res = await axios.post("/obtener-reservas-usuario-admin", {
                params: { idUsuario, rol, pagina: pag, limite: LIMITE },
            });
            setReservas(res.data.reservas || []);
            setTotal(res.data.total || 0);
            setPaginas(res.data.paginas || 0);
            setPagina(pag);
        } catch {
            setReservas([]);
        } finally {
            setCargandoRes(false);
        }
    }

    async function cambiarTab(nuevoTab) {
        setTab(nuevoTab);
        await cargarReservas(usuarioSel.idUsuario, nuevoTab, 1);
    }

    async function cambiarPagina(p) {
        await cargarReservas(usuarioSel.idUsuario, tab, p);
        window.scrollTo({ top: 0, behavior: "smooth" });
    }

    // ── Render ────────────────────────────────────────────────
    return (
        <div className="container-fluid">
            <div className="pt-3 pb-2 mb-4 border-bottom">
                <h1 className="h2 text-dark mb-1">Reservas</h1>
                <p className="text-muted mb-0 small">Busca un usuario para ver sus reservas como comprador o vendedor.</p>
            </div>

            {/* ── Buscador ── */}
            {!usuarioSel && (
                <>
                    <div className="row justify-content-center mb-4">
                        <div className="col-12 col-md-8 col-lg-6">
                            <div className="input-group shadow-sm">
                                <span className="input-group-text bg-white border-end-0 rounded-start-4">
                                    {buscando
                                        ? <span className="spinner-border spinner-border-sm text-primary" role="status" />
                                        : <i className="bi bi-search text-muted"></i>
                                    }
                                </span>
                                <input
                                    type="text"
                                    className="form-control border-start-0 border-end-0 px-0"
                                    placeholder="Buscar usuario por nombre, @usuario o correo..."
                                    value={query}
                                    onChange={onQueryChange}
                                    autoFocus
                                />
                                {query && (
                                    <button
                                        type="button"
                                        className="btn btn-white border border-start-0 rounded-end-4 text-muted"
                                        onClick={() => { setQuery(""); setResultados([]); setBuscado(false); }}
                                        tabIndex={-1}
                                    >
                                        <i className="bi bi-x-lg"></i>
                                    </button>
                                )}
                            </div>
                            {!buscado && !buscando && (
                                <p className="text-center text-muted small mt-3 mb-0">Escribe al menos 2 caracteres para buscar.</p>
                            )}
                        </div>
                    </div>

                    {/* Resultados búsqueda */}
                    {buscado && (
                        <div className="row justify-content-center">
                            <div className="col-12 col-lg-8">
                                {resultados.length === 0 ? (
                                    <div className="border rounded-4 p-5 bg-light text-center">
                                        <i className="bi bi-person-x fs-2 text-muted"></i>
                                        <p className="text-muted small mb-0 mt-2">No se encontraron usuarios para <strong>"{query}"</strong>.</p>
                                    </div>
                                ) : (
                                    <div className="d-flex flex-column gap-2">
                                        {resultados.map((u) => {
                                            const estilo = BADGE_TIPO[u.tipo] || BADGE_TIPO.Usuario;
                                            const nombre = [u.nombre, u.apellido].filter(Boolean).join(" ") || "Sin nombre";
                                            return (
                                                <div
                                                    key={u._id}
                                                    className="card border-0 shadow-sm rounded-4"
                                                    style={{ cursor: "pointer" }}
                                                    onClick={() => seleccionarUsuario(u)}
                                                >
                                                    <div className="card-body py-3 px-4">
                                                        <div className="d-flex align-items-center gap-3">
                                                            <img
                                                                src={u.avatar || "/imagenes/marca/avatar.png"}
                                                                alt={u.username || "avatar"}
                                                                className="rounded-circle flex-shrink-0"
                                                                style={{ width: 44, height: 44, objectFit: "cover" }}
                                                            />
                                                            <div className="flex-grow-1">
                                                                <div className="d-flex align-items-center gap-2 flex-wrap">
                                                                    <span className="fw-semibold text-dark">{nombre}</span>
                                                                    <span className="badge rounded-pill px-2 py-1" style={{ background: estilo.bg, color: estilo.color, fontSize: "0.72rem" }}>
                                                                        {u.tipo || "Usuario"}
                                                                    </span>
                                                                </div>
                                                                <p className="text-muted small mb-0">@{u.username} · {u.email}</p>
                                                            </div>
                                                            <i className="bi bi-chevron-right text-muted"></i>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                )}
                            </div>
                        </div>
                    )}

                    {/* Lista paginada de usuarios */}
                    <div className="row justify-content-center">
                        <div className="col-12 col-lg-10">
                            <div className="d-flex align-items-center justify-content-between mb-3">
                                <h6 className="fw-semibold mb-0 text-dark">Todos los usuarios</h6>
                                <span className="text-muted small">Página {paginaLista} de {paginasLista}</span>
                            </div>

                            {cargandoLista ? (
                                <div className="text-center py-5">
                                    <span className="spinner-border text-primary" role="status" />
                                </div>
                            ) : (
                                <ListaUsuarios
                                    usuarios={lista}
                                    onVer={seleccionarUsuario}
                                    labelBoton="Ver reservas"
                                />
                            )}

                            {paginasLista > 1 && !cargandoLista && (
                                <div className="d-flex justify-content-center align-items-center gap-2 mt-4">
                                    <button
                                        className="btn btn-outline-secondary btn-sm rounded-3"
                                        onClick={() => cambiarPaginaLista(paginaLista - 1)}
                                        disabled={paginaLista === 1}
                                    >
                                        <i className="bi bi-chevron-left"></i>
                                    </button>
                                    {Array.from({ length: paginasLista }, (_, i) => i + 1)
                                        .filter(p => p === 1 || p === paginasLista || Math.abs(p - paginaLista) <= 2)
                                        .reduce((acc, p, idx, arr) => {
                                            if (idx > 0 && p - arr[idx - 1] > 1) acc.push("...");
                                            acc.push(p);
                                            return acc;
                                        }, [])
                                        .map((p, i) =>
                                            p === "..." ? (
                                                <span key={`e-${i}`} className="text-muted px-1">…</span>
                                            ) : (
                                                <button
                                                    key={p}
                                                    className={`btn btn-sm rounded-3 px-3 ${p === paginaLista ? "btn-dark" : "btn-outline-secondary"}`}
                                                    onClick={() => cambiarPaginaLista(p)}
                                                >
                                                    {p}
                                                </button>
                                            )
                                        )
                                    }
                                    <button
                                        className="btn btn-outline-secondary btn-sm rounded-3"
                                        onClick={() => cambiarPaginaLista(paginaLista + 1)}
                                        disabled={paginaLista === paginasLista}
                                    >
                                        <i className="bi bi-chevron-right"></i>
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                </>
            )}

            {/* ── Usuario seleccionado + reservas ── */}
            {usuarioSel && (
                <>
                    {/* Cabecera usuario */}
                    <div className="card border-0 shadow-sm rounded-4 mb-4">
                        <div className="card-body py-3 px-4">
                            <div className="d-flex align-items-center gap-3 flex-wrap">
                                <img
                                    src={usuarioSel.avatar || "/imagenes/marca/avatar.png"}
                                    alt={usuarioSel.username || "avatar"}
                                    className="rounded-circle flex-shrink-0"
                                    style={{ width: 48, height: 48, objectFit: "cover" }}
                                />
                                <div className="flex-grow-1">
                                    <p className="fw-semibold text-dark mb-0">
                                        {[usuarioSel.nombre, usuarioSel.apellido].filter(Boolean).join(" ") || "Sin nombre"}
                                    </p>
                                    <p className="text-muted small mb-0">@{usuarioSel.username} · {usuarioSel.email}</p>
                                </div>
                                <button
                                    className="btn btn-outline-secondary btn-sm rounded-3 flex-shrink-0"
                                    onClick={limpiarSeleccion}
                                >
                                    <i className="bi bi-arrow-left me-1"></i>Buscar otro
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Tabs */}
                    <ul className="nav nav-tabs mb-3">
                        <li className="nav-item">
                            <button
                                className={`nav-link ${tab === "comprador" ? "active fw-semibold" : ""}`}
                                onClick={() => tab !== "comprador" && cambiarTab("comprador")}
                            >
                                <i className="bi bi-bag me-1"></i>Como comprador
                                {tab === "comprador" && total > 0 && (
                                    <span className="badge bg-primary rounded-pill ms-2" style={{ fontSize: "0.7rem" }}>{total}</span>
                                )}
                            </button>
                        </li>
                        <li className="nav-item">
                            <button
                                className={`nav-link ${tab === "proveedor" ? "active fw-semibold" : ""}`}
                                onClick={() => tab !== "proveedor" && cambiarTab("proveedor")}
                            >
                                <i className="bi bi-briefcase me-1"></i>Como vendedor
                                {tab === "proveedor" && total > 0 && (
                                    <span className="badge bg-primary rounded-pill ms-2" style={{ fontSize: "0.7rem" }}>{total}</span>
                                )}
                            </button>
                        </li>
                    </ul>

                    {/* Lista reservas */}
                    {cargandoRes ? (
                        <div className="text-center py-5">
                            <span className="spinner-border text-primary" role="status" />
                        </div>
                    ) : reservas.length === 0 ? (
                        <div className="border rounded-4 p-5 bg-light text-center">
                            <i className="bi bi-calendar-x fs-2 text-muted"></i>
                            <p className="text-muted small mb-0 mt-2">
                                Este usuario no tiene reservas como {tab === "comprador" ? "comprador" : "vendedor"}.
                            </p>
                        </div>
                    ) : (
                        <>
                            <p className="text-muted small mb-3">
                                {total} reserva{total !== 1 ? "s" : ""} · página {pagina} de {paginas}
                            </p>
                            <div className="d-flex flex-column gap-2">
                                {reservas.map((r) => {
                                    const est   = BADGE_ESTADO[r.estado] || {};
                                    const cp    = r.contraparte;
                                    const cpNom = cp ? [cp.nombre, cp.apellido].filter(Boolean).join(" ") : null;
                                    return (
                                        <div
                                            key={r._id}
                                            className="card border-0 shadow-sm rounded-4"
                                            style={{ cursor: "pointer" }}
                                            onClick={() => navigate("/admin/reserva-admin", { state: { params: { idReserva: r._id } } })}
                                        >
                                            <div className="card-body py-3 px-4">
                                                <div className="d-flex align-items-start gap-3 flex-wrap">
                                                    <div className="flex-grow-1 min-w-0">
                                                        <div className="d-flex align-items-center gap-2 flex-wrap mb-1">
                                                            <span className="fw-semibold text-dark">{r.nombreServicio || "Servicio"}</span>
                                                            <span
                                                                className="badge rounded-pill px-2 py-1"
                                                                style={{ background: est.bg, color: est.color, fontSize: "0.72rem" }}
                                                            >
                                                                {est.label || r.estado}
                                                            </span>
                                                            {r.reclamo?.abierto && (
                                                                <span className="badge rounded-pill px-2 py-1" style={{ background: "rgba(var(--rojo-error-rgb), 0.1)", color: "var(--rojo-error)", fontSize: "0.72rem" }}>
                                                                    <i className="bi bi-exclamation-triangle me-1"></i>Reclamo
                                                                </span>
                                                            )}
                                                        </div>
                                                        <div className="text-muted small d-flex flex-wrap gap-3">
                                                            <span><i className="bi bi-calendar3 me-1"></i>{fmt(r.fecha || r.createdAt)}</span>
                                                            {r.cobro?.montoTotal > 0 && (
                                                                <span><i className="bi bi-cash me-1"></i>{fmtMonto(r.cobro.montoTotal)}</span>
                                                            )}
                                                            {cp && (
                                                                <span>
                                                                    <i className={`bi ${tab === "comprador" ? "bi-briefcase" : "bi-bag"} me-1`}></i>
                                                                    {tab === "comprador" ? "Vendedor:" : "Comprador:"}
                                                                    {" "}{cpNom || `@${cp.username}`}
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <i className="bi bi-chevron-right text-muted flex-shrink-0 mt-1"></i>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>

                            {/* Paginación */}
                            {paginas > 1 && (
                                <div className="d-flex justify-content-center align-items-center gap-2 mt-4">
                                    <button
                                        className="btn btn-outline-secondary btn-sm rounded-3"
                                        disabled={pagina === 1}
                                        onClick={() => cambiarPagina(pagina - 1)}
                                    >
                                        <i className="bi bi-chevron-left"></i>
                                    </button>
                                    {Array.from({ length: paginas }, (_, i) => i + 1).map((p) => (
                                        <button
                                            key={p}
                                            className={`btn btn-sm rounded-3 ${p === pagina ? "btn-primary" : "btn-outline-secondary"}`}
                                            onClick={() => p !== pagina && cambiarPagina(p)}
                                        >
                                            {p}
                                        </button>
                                    ))}
                                    <button
                                        className="btn btn-outline-secondary btn-sm rounded-3"
                                        disabled={pagina === paginas}
                                        onClick={() => cambiarPagina(pagina + 1)}
                                    >
                                        <i className="bi bi-chevron-right"></i>
                                    </button>
                                </div>
                            )}
                        </>
                    )}
                </>
            )}
        </div>
    );
}

export default ReservasPorUsuario;
